// Angular imports
import { HttpClient } from '@angular/common/http';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
import { map } from 'rxjs/operators';
import { BaseWorkflowSearchResultDto } from '../_models/workflow-reimbursement-request/base-workflow-search-result-dto';
import { WFReimbursementRequestEditorResultDto } from '../_models/workflow-reimbursement-request/wf-reimbursement-request-editor-result-dto';
import { WFReimbursementRequestLineItemsResultDto } from '../_models/workflow-reimbursement-request/wf-reimbursement-request-line-items-result-dto';
// constant imports
import { URLConstants } from '../../_constants/url-constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class WorkflowReimbursementRequestService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getWorflowReimbursements(baseParam) {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}reimbursement${baseParam.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(BaseWorkflowSearchResultDto, response)));
    }
    getWorkflowReimbursementEditor(baseParam) {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}reimbursement/editor${baseParam.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(WFReimbursementRequestEditorResultDto, response)));
    }
    getWorkflowReimbursementEditorLineItems(baseParam) {
        const url = `${URLConstants.ccWorkflowViewerBaseApiUrl}reimbursement/lineItems${baseParam.getQueryString()}`;
        return this.httpClient
            .get(url)
            .pipe(map((response) => plainToClass(WFReimbursementRequestLineItemsResultDto, response)));
    }
    saveWorkflowReimbursementEditor(baseParam) {
        return this.httpClient
            .post(`${URLConstants.ccWorkflowViewerBaseApiUrl}reimbursement`, classToPlain(baseParam))
            .pipe(map((responseData) => responseData));
    }
    attachLineItemReceipt(baseParam) {
        return this.httpClient
            .post(`${URLConstants.ccWorkflowViewerBaseApiUrl}reimbursement/lineitem/receipt`, classToPlain(baseParam))
            .pipe(map((responseData) => responseData));
    }
    toggleLineItemReimbursement(baseParam) {
        return this.httpClient
            .post(`${URLConstants.ccWorkflowViewerBaseApiUrl}reimbursement/lineitem/toggle`, classToPlain(baseParam))
            .pipe(map((responseData) => responseData));
    }
}
WorkflowReimbursementRequestService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WorkflowReimbursementRequestService_Factory() { return new WorkflowReimbursementRequestService(i0.ɵɵinject(i1.HttpClient)); }, token: WorkflowReimbursementRequestService, providedIn: "root" });
